"use strict";

angular.module("vendor")
.service("ProductOrderSequenceService", function($resource, $http, common, gettextCatalog, FlashBag, appConfig) {
    var masterSequenceRoute = appConfig.API_SERVER + "/catalog/vendor/products/reordering/";
    var masterProductOrderSequenceService = $resource(masterSequenceRoute);
    var sequenceRoute = appConfig.API_SERVER + "/catalog/vendor/products/sequences/:id/reordering/";
    var productOrderSequenceService = $resource(
        sequenceRoute, {
            id: "@id"
        }
    );

    this.query = function(sequenceId) {
        if (sequenceId) {
            return productOrderSequenceService.query({id: sequenceId});
        }
        else {
            return masterProductOrderSequenceService.query();
        }
    };

    this.update = function(sequenceId, productIds) {
        if (sequenceId) {
            return $http({
                method: "POST",
                url: sequenceRoute.replace(":id", sequenceId),
                data: {reordered_ids: productIds}
            });
        }
        else {
            return $http({
                method: "POST",
                url: masterSequenceRoute,
                data: {reordered_ids: productIds}
            });
        }
    };

    this.exportData = function(params) {
        var exportRessource = $resource(appConfig.API_SERVER + "/catalog/vendor/products/sequences/:id/export/", {
            id: "@id"
        }, {
            get: {
                method: "GET",
                isArray: false,
                interceptor: {responseError: FlashBag.responseErrorInterceptor}
            }
        });
        return exportRessource.get(params).$promise.then(function(data) {
            var file_data = data.file_data;
            if (file_data) {
                common.downloadExcelFile(file_data, data.file_name);
            }
            else {
                FlashBag.preformattedError(gettextCatalog.getString("There was an error while generating the file. Please try again."));
            }
        });
    };

    this.importData = function(data) {
        var importRessource = $resource(appConfig.API_SERVER + "/import/product-sequence/", {}, {
            save: {
                transformRequest: angular.identity,
                headers: {"Content-Type": undefined},
                method: "POST",
                interceptor: {responseError: FlashBag.responseErrorInterceptor}
            }
        });
        return importRessource.save(data);
    };
});



//////////////////
// WEBPACK FOOTER
// ./vendor/sections/product/views/sequence/product-sequence-reorder.service.js
// module id = 875
// module chunks = 0